export default "__VITE_ASSET__W28noguq__"